import { useEffect, useRef, useState } from "react";

export function useElementRect<T extends HTMLElement>() {
  const container = useRef<T>(null);
  const [rect, setRect] = useState<DOMRect>();

  useEffect(() => {
    if (container.current === null) {
      return;
    }

    function handleResize() {
      const containerRect = container.current?.getBoundingClientRect();
      setRect(containerRect);
    }

    const resizeObserver = new ResizeObserver(handleResize);
    resizeObserver.observe(container.current);
    handleResize();
    return () => resizeObserver.disconnect();
  }, [container.current]);

  return [container, rect] as const;
}
